var map = {
	"./admin-access/index.js": 7708,
	"./ai-admin/index.js": 9187,
	"./content-management/index.js": 298,
	"./dashboard/index.js": 9904,
	"./error-monitoring/index.js": 1321,
	"./index.js": 1183,
	"./operations/index.js": 1214,
	"./platform-services/index.js": 3269,
	"./posts/index.js": 8792,
	"./sales/index.js": 7014,
	"./settings/index.js": 2761,
	"./support-requests/index.js": 7348,
	"./users/index.js": 4756,
	"./workspaces/index.js": 3186
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9827;